module.exports = __webpack_public_path__ + "static/media/engineirpd3.47afd118.svg";